/* Preserve the order note while Shopify replaces cart sections. */
(() => {
  if (window.SpintzCartNote) return;
  window.SpintzCartNote = true;

  const selector = '[data-spintz-cart-note]';
  let draft;
  let saved;
  let timer;
  let saving = null;
  let submitting = false;
  let status = '';
  const resumedForms = new WeakSet();

  function syncFields() {
    document.querySelectorAll(selector).forEach(field => {
      if (draft === undefined) draft = saved = field.value;
      if (field.value !== draft) field.value = draft;
    });
    document.querySelectorAll('[data-spintz-cart-note-status]').forEach(node => {
      if (node.textContent !== status) node.textContent = status;
    });
  }

  async function save() {
    clearTimeout(timer);
    if (saving || submitting || draft === undefined) return saving;
    if (draft === saved) {
      status = '';
      syncFields();
      return;
    }
    saving = (async () => {
      while (!submitting && draft !== saved) {
        const value = draft;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        status = 'Hinweis wird gespeichert …';
        syncFields();
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: value }),
            keepalive: true,
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Cart note update failed');
          saved = value;
          status = draft === saved ? 'Hinweis gespeichert.' : 'Hinweis wird gespeichert …';
        } catch (_) {
          status = 'Hinweis noch nicht gespeichert. Bitte das Feld erneut verlassen.';
          break;
        } finally {
          clearTimeout(timeout);
          syncFields();
        }
      }
    })().finally(() => { saving = null; });
    return saving;
  }

  document.addEventListener('input', event => {
    if (!event.target.matches?.(selector)) return;
    draft = event.target.value;
    status = 'Hinweis wird gespeichert …';
    syncFields();
    clearTimeout(timer);
    timer = setTimeout(save, 350);
  });

  function saveField(event) {
    if (!event.target.matches?.(selector)) return;
    draft = event.target.value;
    save();
  }
  document.addEventListener('change', saveField);
  document.addEventListener('focusout', saveField);

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.target === '_blank' || (!saving && draft === saved)) return;
    const destination = new URL(link.href, window.location.href);
    const cartPath = `${window.Shopify?.routes?.root || '/'}cart`;
    if (destination.origin !== window.location.origin || destination.pathname.replace(/\/$/, '') !== cartPath) return;
    const form = document.querySelector(selector)?.form;
    if (!form) return;
    event.preventDefault();
    // A normal cart POST carries the note even when the customer opens the cart immediately.
    form.requestSubmit();
  });

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!['cart', 'CartDrawer-Form'].includes(form.id)) return;
    if (resumedForms.has(form)) {
      resumedForms.delete(form);
      return;
    }
    if (event.defaultPrevented) return;
    clearTimeout(timer);
    syncFields();
    // The native form posts the current note, also if its AJAX save failed.
    // Finish an older request first so it cannot overwrite the submitted note.
    if (!saving) return;
    event.preventDefault();
    submitting = true;
    const submitter = event.submitter;
    await saving;
    submitting = false;
    syncFields();
    const liveForm = form.isConnected ? form : document.getElementById(form.id);
    if (!liveForm) return;
    const liveSubmitter = submitter?.isConnected ? submitter
      : submitter?.id ? document.getElementById(submitter.id) : null;
    resumedForms.add(liveForm);
    liveForm.requestSubmit(liveSubmitter?.form === liveForm ? liveSubmitter : undefined);
  });

  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))
    ))) syncFields();
  }).observe(document.documentElement, { childList: true, subtree: true });

  syncFields();
})();
